import { GetPlayerCommissionAdminResponse } from '@/modules/manage-player/type'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { useQuery } from '@tanstack/react-query'
import { getPlayerCommission } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'

export default function useQueryGetPlayerCommission(
	playerId: string,
	props?: Partial<UseBaseQueryOptions<GetPlayerCommissionAdminResponse>>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerCommission, playerId],
		queryFn: () => getPlayerCommission(playerId),
		enabled: Boolean(playerId),
		...props,
	})
}
